module.exports = __webpack_public_path__ + "img/icon-web-home-06.c5254339.png";